export enum WorkspaceStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PAUSED = 'PAUSED',
}

/** Statuses that still let a user open and work inside the workspace. */
export const ACCESSIBLE_WORKSPACE_STATUSES: WorkspaceStatus[] = [
  WorkspaceStatus.ACTIVE,
  WorkspaceStatus.PAUSED,
];
